import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';

import {useNavigate} from 'shared/web';

import {Packages} from './(sections)/Packages/Packages';
import {PackagesCategory} from './(sections)/PackagesCategory/PackagesCategory';

export function WorkshopServicePackages() {
  const navigate = useNavigate();

  const header: SettingsTemplateHeader = {
    title: i18n.t('entity.workshopServicePackages.labels.title'),
    actions: [
      {
        type: 'button',
        title: i18n.t('entity.workshopServicePackages.actions.newServicePackage'),
        onClick: () => navigate(settingsRoutes.workshopCreateServicePackages),
      },
    ],
  };

  return (
    <>
      <Helmet title={i18n.t('entity.workshopServicePackages.labels.title')} />
      <SettingsTemplate
        data-testid={testIds.settings.workshopServicePackages('template')}
        header={header}
        tabs={[
          {
            queryId: 'packages',
            title: i18n.t('entity.workshopServicePackages.labels.packages'),
            content: (
              <Packages data-testid={testIds.settings.workshopServicePackages('packages')} />
            ),
          },
          {
            queryId: 'categories',
            title: i18n.t('entity.workshopServicePackages.labels.categories'),
            content: (
              <PackagesCategory
                data-testid={testIds.settings.workshopServicePackages('category')}
              />
            ),
          },
        ]}
      />
    </>
  );
}
